import { UserActivity } from 'common/core/interfaces/userActivity'

export const initialState: UserActivity = {
  was_in_process: null,
  isShowed: false,
}
